import script from "./ttsMultiple.vue?vue&type=script&setup=true&lang=ts"
export * from "./ttsMultiple.vue?vue&type=script&setup=true&lang=ts"

import "./ttsMultiple.vue?vue&type=style&index=0&id=f6568a36&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6568a36"]])

export default __exports__